/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleDownIcon20Light = forwardRef('ArrowFigureACircleDownIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.5 5.5a.5.5 0 0 1 .5.5v6.219l2.116-2.54a.5.5 0 1 1 .768.641l-2.232 2.678a1.5 1.5 0 0 1-2.304 0L6.116 10.32a.5.5 0 0 1 .768-.64L9 12.219V6a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 2a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15ZM16 9.5a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0Z" })));
});
